import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onChangePlanClick", "subscriptionLevelDescription", "subscriptionLevelMonthlyCostFormatted", "user", "monthlyCostMessage"];
import React from 'react';
import { Segment, Header } from 'semantic-ui-react';
import { ButtonLink } from '@emyw/auth-lib';
import '../custom-theme.css';
var getDescription = function getDescription(user, subscriptionLevelDescription) {
  if (user) {
    return user.subscriptionLevelDescription;
  }
  return subscriptionLevelDescription;
};
export var getCost = function getCost(user, subscriptionLevelMonthlyCostFormatted) {
  var price = subscriptionLevelMonthlyCostFormatted;
  if (user) {
    price = user.subscriptionLevelMonthlyCostFormatted;
  }
  price = "".concat(price).concat(parseFloat((price || '0').replace(/[^\d.-]/g, '')) === 0 && price.indexOf('+tax') === -1 ? '' : '+tax');
  return price;
};
var PlanDetail = function PlanDetail(_ref) {
  var onChangePlanClick = _ref.onChangePlanClick,
    subscriptionLevelDescription = _ref.subscriptionLevelDescription,
    subscriptionLevelMonthlyCostFormatted = _ref.subscriptionLevelMonthlyCostFormatted,
    user = _ref.user,
    monthlyCostMessage = _ref.monthlyCostMessage,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Segment, Object.assign({
    className: "subscriptionPlanSummary",
    clearing: true,
    size: "mini"
  }, props), /*#__PURE__*/React.createElement(Header, {
    className: "subscribeDetailSummary lighter",
    floated: "left",
    style: {
      margin: 'auto',
      whiteSpace: 'pre-line',
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "planDescription"
  }, getDescription(user, subscriptionLevelDescription)), /*#__PURE__*/React.createElement("b", null, "".concat(getCost(user, subscriptionLevelMonthlyCostFormatted))), monthlyCostMessage || ''), /*#__PURE__*/React.createElement(Header, {
    className: "changeSubscribeItem light",
    floated: "right"
  }, user && !user.iapPlatform && /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onChangePlanClick
  }, "Change Plan")));
};
PlanDetail.defaultProps = {
  user: undefined,
  subscriptionLevelDescription: undefined,
  subscriptionLevelMonthlyCostFormatted: undefined,
  monthlyCostMessage: undefined
};
export default PlanDetail;